import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
// Query keys for league venue operations
const USE_LIST_LEAGUE_HOME_VENUES = "useListLeagueHomeVenues";
// League venue listing hook
export const useListLeagueHomeVenues = ({ leagueId, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_LIST_LEAGUE_HOME_VENUES, leagueId],
        queryFn: async () => {
            const { data } = await api.get(`/leagues/${leagueId}/venues/`);
            return data;
        },
        enabled: !!leagueId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useAddVenueToLeague = ({ onSuccess, onError, leagueId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            return api.post(`/league-venues/`, data);
        },
        onSuccess: (data) => {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            onSuccess(data);
        },
        onError,
    });
};
// Deactivate venue hook
export const useDeactivateVenueFromLeague = ({ onSuccess, onError, leagueId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ leagueVenueId, ...data }) => {
            return api.post(`/league-venues/${leagueVenueId}/deactivate/`, data);
        },
        onSuccess: (data) => {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            onSuccess(data);
        },
        onError,
    });
};
export const useRemoveVenueFromLeague = ({ onSuccess, onError, leagueId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (leagueVenueId) => {
            return api.delete(`/league-venues/${leagueVenueId}/`);
        },
        onSuccess: () => {
            // Use the leagueId passed as parameter
            if (leagueId) {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES, leagueId]);
            }
            else {
                queryClient.invalidateQueries([USE_LIST_LEAGUE_HOME_VENUES]);
            }
            onSuccess();
        },
        onError,
    });
};
